import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const certifications = [
  { name: 'SAM Registration', status: 'Active' },
  { name: 'CAGE Code', status: '9Y0X3' },
  { name: 'PMP Certified', status: 'Project Management Professional' },
  { name: 'CSM / CSPO', status: 'Certified ScrumMaster / Product Owner' },
  { name: 'PMI-ACP', status: 'Agile Certified Practitioner' },
  { name: 'SAFe SPC', status: 'SAFe Program Consultant' },
  { name: 'Oracle Cloud Certified', status: 'Financials & EPM' },
  { name: 'Small Business', status: 'Atlanta, GA' },
];

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="py-24 lg:py-32 bg-[#141414]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
            Credentials
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4">
            Certifications & Registrations
          </h2>
          <p className="font-body text-[#A3A3A3] max-w-lg">
            Our team maintains the certifications and registrations required to operate
            at the highest levels of government contracting.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {certifications.map((cert, i) => (
            <motion.div
              key={cert.name}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              data-testid={`cert-card-${i}`}
              className="p-5 bg-[#0A0A0A] border border-[#2A2A2A] rounded-lg hover:border-[#B8102E]/30 transition-all duration-300"
            >
              <CheckCircle2 className="h-5 w-5 text-[#B8102E] mb-3" />
              <p className="font-body text-sm text-white font-medium mb-1">
                {cert.name}
              </p>
              <p className="font-body text-xs text-[#737373]">
                {cert.status}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
